import React from 'react'
import { find, map, orderBy, last } from 'lodash'
import getSymbolFromCurrency from 'currency-symbol-map'
import { parse, format } from 'date-fns'
import { ellipsifyByChar } from '~/tools/strings/ellipsify'
import { getMyBillingHistory } from '~/redux/user/subscription'
import connect from '~/tools/connect'
import { fetchModels } from '~/redux/models/helpers'
import userStore from '~/redux/user/store'
import { getLocalizedVal } from '~/tools/localization/helpers';
import './style.css'

class View extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fields: props.args.fields
    }
  }

  async componentDidMount() {
    this.setState({ model: await fetchModels() })
    getMyBillingHistory().then( r => {
      this.setState({
        ...this.state,
        billingHistory: {
          ...r.data,
          Items: orderBy( r.data.Items, item => parse(item.initiatedAt), 'desc')
        }
      })
    })
  }

  capitalize(string) {
    var str = string.toLowerCase()
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  formatDate(date) {
    return format(date, 'MM/DD/YYYY')
  }

  getLocalizedPurchaseType(purchaseType) {
    if(purchaseType.toLowerCase() === 'rent') {
      return getLocalizedVal(window.settings,'genericMessages', 'rentOverlayLabel')
    } else if(purchaseType.toLowerCase() === 'purchase') {
      return getLocalizedVal(window.settings,'genericMessages', 'purchaseOverlayLabel')
    }
    return purchaseType;
  }

  render() {
    const billingHistory = this.state.billingHistory

    if (!this.state.billingHistory) {
      return null
    } else if (!billingHistory.Items.length) {
      return <div className="centered">{this.state.fields.noBillingMessage}</div>
    }

    if (!this.state.user.subscription) { 
      return (
        <div className="billing-history centered padded">
          <div className="transactions-wrapper">
            <div className="transactions">
              <h1>{this.state.fields.billingHistoryButtonText}</h1>
              <table>
                <thead>
                  <tr>
                    <th>{this.state.fields.billingHistoryTableDate}</th>
                    <th>{this.state.fields.billingHistoryTableTitle}</th>
                    <th>{this.state.fields.billingHistoryTableType}</th>
                    <th>{this.state.fields.billingHistoryTableDescription}</th>
                    <th>{this.state.fields.billingHistoryTableOffers}</th>
                    <th>{this.state.fields.billingHistoryTableTotal}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.billingHistory && this.renderBillingHistoryItems()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
    }

    const subscription = this.state.user.subscription
    const { countryCode, subscriptionEndDate } = subscription.subscriptionInfo || {}
    const actualPrice = find(subscription.subscriptionPlanInfo.planDetails, { countryCode: countryCode })

    var isActiveSubscription = this.state.user.subscription.subscriptionInfo.subscriptionStatus !== 'CANCELLED'
    var userWillBeCharged = this.state.user.subscription.subscriptionInfo.subscriptionStatus === 'COMPLETED'
    var localizedPlanFrequency = ""
    if(subscription.subscriptionPlanInfo.renewalCycleType.toLowerCase() === "year") {
      localizedPlanFrequency = this.state.fields.billingHistoryYearLocalization || "year"
    } else if(subscription.subscriptionPlanInfo.renewalCycleType.toLowerCase() === "month") {
      localizedPlanFrequency = this.state.fields.billingHistoryMonthLocalization || "month"
    } else {
      localizedPlanFrequency = subscription.subscriptionPlanInfo.renewalCycleType.toLowerCase()
    }

    return (
      <div className="billing-history centered padded">
          { isActiveSubscription && (
            <div className="plan-info">
              <div className="title">{subscription.subscriptionPlanInfo.planDetails[0].title || subscription.subscriptionPlanInfo.name}</div>
              <div className="desc">{subscription.subscriptionPlanInfo.planDetails[0].description || subscription.subscriptionPlanInfo.description}</div>
            {actualPrice && <div className="price">
                {getSymbolFromCurrency(subscription.subscriptionInfo.currencyCode)}{actualPrice.recurringPaymentAmount} {this.state.fields.billingHistoryPerSeparator} {localizedPlanFrequency}
              </div>}

            </div>
          ) }
          <div className="major-dates">
            <span className="join-date">
              <b>{this.state.fields.billingHistoryJoinDatelabel}: </b>
              { this.formatDate(last(billingHistory.Items).subscriptionStartDate) }
            </span><br />
            <span className="last-charge">
              <b>{this.state.fields.billingHistoryLastChargeLabel}: </b>
              { this.formatDate(billingHistory.Items[0].completedAt) }
            </span> <br />
            { userWillBeCharged && subscriptionEndDate && (
              <span className="next-charge">
                <b>{this.state.fields.billingHistoryNextChargeLabel}: </b>
                { this.formatDate(subscriptionEndDate) }
              </span>
            ) }
          </div>
          <div className="transactions-wrapper">
            <div className="transactions">
              <h1>{this.state.fields.billingHistoryButtonText}</h1>
              <table>
                <thead>
                  <tr>
                    <th>{this.state.fields.billingHistoryTableDate}</th>
                    <th>{this.state.fields.billingHistoryTableTitle}</th>
                    <th>{this.state.fields.billingHistoryTableServicePeriod}</th>
                    <th>{this.state.fields.billingHistoryTableDescription}</th>
                    <th>{this.state.fields.billingHistoryTableOffers}</th>
                    <th>{this.state.fields.billingHistoryTableTotal}</th>
                  </tr>
                </thead>
                <tbody>
                  { this.renderBillingHistoryItems() }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
  }

  renderBillingHistoryItems() {
    return map(this.state.billingHistory.Items, (item, i) => {
      return <tr key={item.id} className="billing-item">
          <td className="date">
            { this.formatDate(item.initiatedAt || item.initiatedDate) }
          </td>
          <td className="title">
          { (item.title && ellipsifyByChar(item.title, 40)) || 'N/A' }
          </td>
          { this.state.model === 'SVOD' && item.purchaseType ? 
            <td className="service-period">
              { this.formatDate(item.subscriptionStartDate) } - { this.formatDate(item.subscriptionEndDate) }
            </td> : <td className="purchase-type">
            { item.purchaseType ? this.capitalize(this.getLocalizedPurchaseType(item.purchaseType)) : 'N/A' }
          </td> }
          <td className="description-type">
          { this.capitalize(item.transactiontype || item.transactionType) }
          </td>
          <td>{(item.offerName && item.offerName) || 'N/A'}</td>
          <td className="total">
            { getSymbolFromCurrency(item.currencyCode) }
            {item.totalAmount}
          </td>
        </tr>;
    })
  }
}

connect(View, state => ({ user: state.user }), userStore)

export default View;